'use strict';
var { default: Player } = require('@vimeo/player');
var utils = require('pagedesigner/util/utils');
var processInclude = require('base/util');
processInclude(require('pagedesigner/experience/modal'));

/**
 * Modules Media Backgroud - Make videos height fluid on load and resize
 * @param {HTMLElement} element - Player iframe
 */
function adjustVideoFrameByAspectRatio(element) {
    const parent = element.parentElement;
    const parentWidth = element.offsetWidth;
    const parentHeight = parent.offsetHeight;
    const parentAspectRatio = parentWidth / parentHeight;
    const elementAspectRatio = parent.getAttribute('data-aspect-ratio');

    if (parentAspectRatio > elementAspectRatio) {
        // Parent is wider relative to its height compared to the element
        // Adjust element's width to match the parent's aspect ratio
        element.style.width = '100%';
        element.style.height = 'unset';
    } else {
        // Parent is taller relative to its width compared to the element
        // Adjust element's height to match the parent's aspect
        element.style.width = 'unset';
        element.style.height = '100%';
    }
}

/**
 * Updated video state
 * @param {HTMLElement} container - Player container
 * @param {boolean} pause - Command to player
 */
function updateVideoState(container, pause) {
    var video = $(container).find('div[id*="iframePlayer"]');
    var videoId = video[0].id.split('-')[1];

    if (typeof Player === 'undefined') {
        console.info('Vimeo is not defined');
        return;
    }

    var player = new Player('iframePlayer-' + videoId);

    player.ready().then(function () {
        if (video[0].classList.contains('video-frame-fluid-size')) {
            adjustVideoFrameByAspectRatio(player.element);
        }
        var altText = $(container).data('alt');
        if (altText) {
            player.element.setAttribute('title', altText);
            player.element.setAttribute('aria-label', altText);
        }
    });

    if (pause) {
        player
            .pause()
            .then(function () {})
            .catch(function (error) {
                console.info('Video could not be played', error);
                player.destroy();
            });
    } else if (video[0].hasAttribute('data-autoplay') && video[0].getAttribute('data-autoplay') === 'true') {
        player
            .play()
            .then(function () {
                console.info('Video started playing', player);
            })
            .catch(function (error) {
                console.info('Video could not be played', error);
                player.destroy();
            });
    }
}
/**
 * Update responsive videos based on viewport.
 * Handles desktop-only, mobile-only, and dual-video components:
 * - Both videos: play the viewport-appropriate one, pause the other
 * - Desktop only: play on all viewports (no mobile alternative to swap to)
 * - Mobile only: play on mobile, pause on desktop
 */
function updateVideos() {
    var isMobileViewport = utils.mediaBreakpointDown('md');

    $('.video-frame-wrapper').each(function () {
        var $wrapper = $(this);
        var isMobileFrame = $wrapper.hasClass('video-frame-mobile');
        var hasMobileAlternative = isMobileFrame || $wrapper.siblings('.video-frame-mobile').length > 0;
        var shouldPlay;

        if (isMobileViewport) {
            // Play mobile frame, or desktop frame when it has no mobile sibling
            shouldPlay = isMobileFrame || !hasMobileAlternative;
        } else {
            // Play any non-mobile frame (desktop-tagged or desktop-only without the class)
            shouldPlay = !isMobileFrame;
        }

        updateVideoState(this, !shouldPlay);
    });
}

/**
 * Creates the video modal full screen jQuery element
 * @param {string} video - the modal's ID
 * @param {string} videoMobile - the video mobile ID
 * @param {boolean} enableControls - the video controllers
 * @returns {jQuery} - a modal
 */
function videoModalFullScreen(video, videoMobile, enableControls) {
    var html =
    `
    <div id="videoModal-${utils.mediaBreakpointDown('sm') ? videoMobile : video}" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered video-modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>
                <iframe src="https://player.vimeo.com/video/${utils.mediaBreakpointDown('sm') ? videoMobile : video}?h=db5f8cb947&badge=0&autopause=0&player_id=0&app_id=58479&controls=${enableControls}&loop=false&autoplay=true&muted=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" class="video-frame" id="${utils.mediaBreakpointDown('sm') ? videoMobile : video}"></iframe>
            </div>
        </div>
    </div>
    `;

    return $(html);
}

$(document).ready(function () {
    if ($('.video-frame-wrapper').length > 0) {
        updateVideos();
        utils.smartResize(function () {
            updateVideos();
        });
    }
});

$(document).on('click', '.play-video-modal', function (e) {
    e.preventDefault();
    var $link = $(e.currentTarget);
    var video = $link.data('video');
    var videoMobile = $link.data('video-mobile');
    var enableControls = $link.data('controllers');

    $.spinner().start();
    var $modal = videoModalFullScreen(video, videoMobile, enableControls);
    $('body').append($modal);
    $modal.on('show.bs.modal', function () {
        $modal.focus();
    });
    $modal.on('shown.bs.modal', function () {
        $("[id*='videoModal'] .close").trigger('focus');
    });
    $modal.on('hidden.bs.modal', function () {
        $modal.remove();
    });
    $modal.modal('show');
    $.spinner().stop();
});
